<template>
  <v-autocomplete 
    v-bind="$attrs"
    v-on="$listeners"
    browser-autocomplete="no"
    autocomplete="NoAutocomplete"
  />
</template>

<script>
export default {
  name: 'ViteAutocomplete'
}
</script>



// WEBPACK FOOTER //
// src/components/ViteAutocomplete.vue